import { render, staticRenderFns } from "./DataAppDIMReport.vue?vue&type=template&id=4dbe136a&"
import script from "./DataAppDIMReport.vue?vue&type=script&lang=js&"
export * from "./DataAppDIMReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dbe136a')) {
      api.createRecord('4dbe136a', component.options)
    } else {
      api.reload('4dbe136a', component.options)
    }
    module.hot.accept("./DataAppDIMReport.vue?vue&type=template&id=4dbe136a&", function () {
      api.rerender('4dbe136a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ddv-home/DataAppDIMReport.vue"
export default component.exports